import { render, staticRenderFns } from "./manageGoods1 copy.vue?vue&type=template&id=53bf7b8f&scoped=true&"
import script from "./manageGoods1 copy.vue?vue&type=script&lang=js&"
export * from "./manageGoods1 copy.vue?vue&type=script&lang=js&"
import style0 from "./manageGoods1 copy.vue?vue&type=style&index=0&id=53bf7b8f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf7b8f",
  null
  
)

export default component.exports